import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@pc/components/ui/skeleton';
function RankingSkeleton() {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <th className="h-[50px] w-[60px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <th align="center" className="w-[100px]"><Skeleton className="h-[35px] w-[90%]" /></th>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <th align="center" colSpan={2}><Skeleton className="h-[35px] w-[90%]" /></th>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <th align="center"><Skeleton className="h-[35px] w-[90%]" /></th>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <th align="center"><Skeleton className="h-[35px] w-[90%]" /></th>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <th align="center"><Skeleton className="h-[35px] w-[90%]" /></th>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <th align="center" colSpan={1}><Skeleton className="h-[35px] w-[90%]" /></th>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <th align="center" colSpan={1}><Skeleton className="h-[35px] w-[90%]" /></th>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className=""><table className="w-full "><thead><tr className="border-t-2 border-t-[#3e4452] border-b-[#a5a5a5] border-b-[1px] font-bold text-[#555]">{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}<th align="center" colSpan={1}><Skeleton className="h-[35px] w-[90%]" /></th></tr></thead><tbody>{Array.from({
            length: 12
          }).map(_temp)}</tbody></table></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}
function _temp(_, index) {
  if (index >= 200) {
    return null;
  }
  return <tr key={Number(index)}><td className="center relative py-[12px]"><div className="relative w-[56px]"><span className="relative z-0 block h-14 w-14 overflow-hidden rounded-full bg-white"><Skeleton className="-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 z-10 h-full w-full object-cover" /></span></div></td><td className="flex h-[80px] items-center justify-center text-center"><Skeleton className="h-[35px] w-[80%]" /></td><td className="text-center"><Skeleton className="h-[35px] w-[80%]" /></td><td className="text-center"><Skeleton className="h-[35px] w-[80%]" /></td><td className="text-center"><Skeleton className="h-[35px] w-[80%]" /></td><td className="text-center"><Skeleton className="h-[35px] w-[80%]" /></td><td className="text-center"><Skeleton className="h-[35px] w-[80%]" /></td><td width={80} className="text-center"><div className="flex justify-center"><Skeleton className="h-[35px] w-[80%]" /></div></td><td width={80} className="text-center"><div className="flex justify-center"><Skeleton className="h-[35px] w-[80%]" /></div></td><td width={80} className="text-center"><div className="flex justify-center"><Skeleton className="h-[35px] w-[80%]" /></div></td></tr>;
}
export default RankingSkeleton;